// First-time onboarding flag (stored per user in this browser).
const keyFor = () => {
  let id = localStorage.getItem('userId');
  try {
    const u = JSON.parse(localStorage.getItem('user') || 'null');
    id = u?._id || u?.id || id;
  } catch (e) {}
  return `morphosys_onboarding_completed_${id || 'anon'}`;
};

export const hasCompletedOnboarding = () => localStorage.getItem(keyFor()) === 'true';
export const markOnboardingCompleted = () => localStorage.setItem(keyFor(), 'true');

// After registration: new users go straight to the Film / TV / Treatment picker.
export const goToPostRegister = (navigate) =>
  hasCompletedOnboarding()
    ? navigate('/home')
    : navigate('/home', { replace: true, state: { openCreateScript: true } });
